import { useCallback, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import ReactGA from 'react-ga4'
import { useLocation } from 'react-router-dom'
import { getAppConfig } from 'app-config'

const GoogleAnalytics4 = ({ options = {} }) => {
  const config = getAppConfig()
  const [tracking, setTracking] = useState(false)
  const location = useLocation()
  const { pathname, search } = location

  const trackPage = useCallback(() => {
    const page = pathname + search
    const { location: winLocation } = window

    ReactGA.set({
      page,
      location: `${winLocation.origin}${page}`,
      ...options,
    })

    ReactGA.send({ hitType: 'pageview', page })
    console.log('[GA4] pageview tracked: ', page)
  }, [options, pathname, search])

  useEffect(() => {
    if (tracking) {
      trackPage()
    }
  }, [pathname, search, tracking, trackPage])

  useEffect(() => {
    ReactGA.initialize(config.app.ga4)
    console.log('[GA4] initialized: ', config.app.ga4)
    setTracking(true)
  }, [config.app.ga4])

  return null
}

GoogleAnalytics4.propTypes = {
  options: PropTypes.object
}

export default GoogleAnalytics4
